<script>
import { HorizontalBar } from "vue-chartjs";
import pluginConfig from "../../services/graphPlugins.js";

export default {
  extends: HorizontalBar,
  props: {
    args: { type: Object, required: true }
  },
  data() {
    return {
      feedIndex: 0,
      highestValue: 0
    };
  },
  watch: {
    args: {
      async handler() {
        await this.renderGraph();
      }
    }
  },
  async mounted() {
    await this.addPlugin(pluginConfig.labelOutside(this._data._chart));
    await this.renderGraph();
  },
  methods: {
    graphData() {
      return {
        labels: this.args.labels,
        datasets: this.args.datasets.map(set => ({
          label: set.name || this.args.labelPrefix || "",
          backgroundColor: set.color || "blue",
          borderWidth: 2,
          pointBorderWidth: 1,
          pointRadius: 1,
          pointHoverRadius: 5,
          pointHitRadius: 10,
          data: set.values,
          lineTension: 0.2,
          hoverBackgroundColor: set.color || "blue"
        }))
      };
    },
    renderGraph() {
      const context = this;
      this.renderChart(this.graphData(), {
        animation: false,
        tooltips: {
          yAlign: "10",
          xAlign: "20",
          displayColors: false,
          bodyFontColor: "black",
          bodyFontSize: 12,
          bodyFontStyle: "bold",
          backgroundColor: "transparent",
          caretSize: 0,
          callbacks: {
            afterBody(tooltipItem) {
              // the click event returns incorrect index so we add it on the hover event
              context.feedIndex = tooltipItem[0].datasetIndex;
            },
            label(ti, data) {
              const unit = data.datasets[ti.datasetIndex].data[ti.index];
              return unit;
            },
            labelTextColor(ti) {
              if (context.args.datasets.length < 2) {
                return context.args.datasets[ti.datasetIndex].color[ti.index];
              }
              return context.args.datasets[ti.datasetIndex].color;
            },
            title() {
              return;
            }
          }
        },
        legend: { display: this.args.legend },
        layout: { padding: { top: -10 } },
        scales: {
          yAxes: [
            {
              barPercentage: 0.5
            }
          ],
          xAxes: [
            {
              ticks: {
                suggestedMax: this.args.scale || 0,
                suggestedMin: 0,
                callback(value) {
                  return value + context.args.unit;
                }
              }
            }
          ]
        },
        responsive: true,
        showAllTooltips: true,
        maintainAspectRatio: false,
        onClick: (_, arr) => {
          this.$nextTick(() => {
            if (arr.length && !isNaN(arr[0]._index)) {
              this.$emit(
                "onDataClick",
                arr[0],
                this.feedIndex,
                this.args.labels[arr[0]._index]
              );
            }
          });
        }
      });
    },
    formatDate(d) {
      if (!isNaN(Number(d))) {
        return `${d.substring(6, 8)}-${d.substring(4, 6)}-${d.substring(0, 4)}`;
      }
      return d;
    }
  }
};
</script>
